module.exports = __webpack_public_path__ + "img/hangyebiaozhun2.85386728.png";